import { useTranslation } from 'react-i18next';
import { isAdmin } from '../utils/roleUtils';
import { useTheme } from '../contexts/ThemeContext';
import AdminOperationsWorkspace from './operations/AdminOperationsWorkspace';
import DriverOperationsWorkspace from './operations/DriverOperationsWorkspace';

const OperationsPage = ({ currentEntity, userRole }) => {
  const { t } = useTranslation();
  const { background, text, cn } = useTheme();
  const adminMode = isAdmin(userRole);

  return (
    <main className={cn('min-h-screen', background.primary)}>
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <h1 className={cn('text-3xl font-bold', text.primary)}>
          {t('operations.title')}
        </h1>
        <p className={cn('mt-2', text.muted)}>
          {adminMode
            ? t('operations.adminHelp')
            : t('operations.driverHelp')}
        </p>
      </header>

      {adminMode ? (
        <AdminOperationsWorkspace
          key={`admin-${currentEntity?.entityId || 'none'}`}
          currentEntity={currentEntity}
          userRole={userRole}
        />
      ) : (
        <DriverOperationsWorkspace
          key={`driver-${currentEntity?.entityId || 'none'}`}
          currentEntity={currentEntity}
        />
      )}
    </main>
  );
};

export default OperationsPage;
